import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HardwareSensor} from './hardwareSensor';

@Injectable({
  providedIn: 'root'
})
export class HardwareSensorService {

  private basePath = "api/v1/sergas_device";

  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  getAllBySergasSensor(sergasDeviceId:string, sergasSensorId:string): Promise<any>{
    let url = this.basePath + "/" + sergasDeviceId + "/sergas_sensor/" + sergasSensorId + "/hardware_sensor";
    return this.http.get(url)
      .toPromise()
      .then( res => res as HardwareSensor[])
      .catch( error => this.errorHandler(error) );
  }
}
